import React, { useState, useEffect, Fragment, useRef } from 'react';
import { useAlert } from 'react-alert';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../../utils/permissionAuth';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import Page from 'src/components/Page';
import { Box, Button, Card, CardContent, CardHeader, Container, Grid, InputLabel, makeStyles, MenuItem, Paper, Table, TableBody, TableCell, TableContainer, TableRow, TextField, Typography } from '@material-ui/core';
import { Formik } from 'formik';
import PerfectScrollbar from 'react-perfect-scrollbar';
import DateFnsUtils from '@date-io/date-fns';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { LoadingComponent } from 'src/utils/newLoader';
import tokenService from '../../../../utils/tokenDecoder';
import tokenDecoder from '../../../../utils/tokenDecoder';
import services from '../Services';
import * as Yup from 'yup';
import ReactToPrint from 'react-to-print';
import moment from 'moment';
import CreatePDF from './CreatePDF';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: 'red'
  },
  colorRecord: {
    backgroundColor: 'green'
  }
}));

const screenCode = 'PROFITANDLOSSREPORTRTF';

export default function ProfitAndLossReportRTF(props) {
  const alert = useAlert();
  const navigate = useNavigate();
  const classes = useStyles();
  const [GroupList, setGroupList] = useState([]);
  const [FactoryList, setFactoryList] = useState();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [title, setTitle] = useState('Profit & Loss Report - RTF');
  const [IsReportVisible, setIsReportVisible] = useState(false);
  const [IsBalanceEntry, setIsBalanceEntry] = useState(false);
  const [IsOpeningDisabled, setIsOpeningDisabled] = useState(false);
  const [IsClosingDisabled, setIsClosingDisabled] = useState(false);
  const [IsSearchButtonVisible, setIsSearchButtonVisible] = useState(true);
  const [openingAmountForReport, setOpeningAmountForReport] = useState(0);
  const [closingAmountForReport, setClosingAmountForReport] = useState(0);
  const [searchValues, setSearchValues] = useState({
    groupID: 0,
    factoryID: 0,
    applicableMonth: moment(new Date()).format('MM'),
    applicableYear: moment(new Date()).format('YYYY')
  });
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: '',
    factoryName: '',
    applicableMonth: '',
    applicableYear: ''
  });
  const [inventoryBalance, setInventoryBalance] = useState({
    openingStock: 0,
    openingUnitPrice: 0,
    openingAmount: 0,
    closingStock: 0,
    closingUnitPrice: 0,
    closingAmount: 0
  })
  const componentRef = useRef();
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
    isProfitAndLossConfigurationEnabled: false
  });
  const [stockValue, setStockValue] = useState({
    OpeningBalance: 0,
    ProductionCost: 0,
    ClosingBalance: 0
  });
  const [income, setIncome] = useState({
    SalesProceedIncome: 0,
    RefuseTeaIncome: 0,
    LocalSales: 0,
    FertilizerSaleProfit: 0,
    InterestIncome: 0,
    GroceriesProfit: 0,
    TransportIncome: 0,
    VegetableSaleProfit: 0,
    ChemicalSaleProfit: 0,
    OtherIncome: 0
  });
  const [administrationExpenses, setAdministrationExpenses] = useState({
    Water: 0,
    TotalTelephoneChargersWithStarLink: 0,
    Bonus: 0,
    OfficeStaffSalary: 0,
    StaffEPF: 0,
    StaffETFWithEmployeeTrustFund: 0,
    MealsExpenses: 0,
    ElectricityCharges: 0,
    SundryExpenses: 0,
    PrintingAndStationary: 0,
    Postage: 0,
    SecurityOfficersSalary: 0,
    VehicleDepreciation: 0,
    FertilizerLoadingAndUnloading:0,
    AnnualExpenses:0
  });
  const [distributionExpenses, setDistributionExpenses] = useState({
    MadeTeaTransport: 0,
    VehicleDepreciationColombo: 0,
    Brokerage: 0,
    SampleCost: 0,
    Fuel: 0,
    VehicleMaintenance: 0
  });
  const [financialExpenses, setFinancialExpenses] = useState({
    LoanInterest: 0,
    ODInterest: 0,
    BankCharges: 0,
  });
  const [otherExpenses, setOtherExpenses] = useState({
    MedicalExpenses: 0,
    Donation: 0,
    Welfare: 0,

  });
  const [totals, setTotals] = useState({
    SalesTotal: 0,
    StockValue: 0,
    GrossProfit: 0,
    TotalOtherIncome: 0,
    TotalIncome: 0,
    TotalAdministrationExpenses: 0,
    TotalDistributionExpenses: 0,
    TotalFinancialExpenses: 0,
    TotalOtherExpenses: 0,
    TotalExpenses: 0,
    ProfitORLoss: 0
  });

  useEffect(() => {
    trackPromise(getPermission());
    trackPromise(getGroupsForDropdown());
  }, []);

  useEffect(() => {
    trackPromise(getFactoriesForDropDown());
  }, [searchValues.groupID]);

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(
      p => p.permissionCode == 'VIEWPROFITANDLOSSREPORTRTF'
    );
    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(
      p => p.permissionCode == 'GROUPDROPDOWN'
    );
    var isFactoryFilterEnabled = permissions.find(
      p => p.permissionCode == 'FACTORYDROPDOWN'
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
    });

    setSearchValues({
      ...searchValues,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    });
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropDown() {
    const factory = await services.getFactoryByGroupID(
      searchValues.groupID
    );
    setFactoryList(factory);
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  async function GetOpeningClosingforPnLRTFDetails() {
    setIsOpeningDisabled(false);
    setIsClosingDisabled(false);
    addSelectedSearchValues();
    let model = {
      groupID: parseInt(searchValues.groupID),
      factoryID: parseInt(searchValues.factoryID),
      applicableMonth: searchValues.applicableMonth === '' ? moment(new Date()).format('MM') : searchValues.applicableMonth,
      applicableYear: searchValues.applicableYear === "" ? moment(new Date()).format('YYYY') : searchValues.applicableYear,
    };
    const response = await services.getOpeningClosingforPnLRTFDetails(model);
    if (response.statusCode === 'Success') {
      setIsSearchButtonVisible(false);
      if (response.data.length !== 0) {
        setInventoryBalance({
          openingStock: response.data[0].openingStock,
          openingUnitPrice: response.data[0].openingUnitPrice,
          openingAmount: response.data[0].openingAmount,
          closingStock: response.data[0].closingStock,
          closingUnitPrice: response.data[0].closingUnitPrice,
          closingAmount: response.data[0].closingAmount
        });
        setIsOpeningDisabled(false);
        setIsClosingDisabled(false);
        if (response.data[0].openingAmount !== 0) {
          //setIsOpeningDisabled(true);
          setOpeningAmountForReport(response.data[0].openingAmount);
        }
        if (response.data[0].closingAmount !== 0) {
          //setIsClosingDisabled(true);
          setClosingAmountForReport(response.data[0].closingAmount);
        }
      } else {
        setInventoryBalance({
          openingStock: 0,
          openingUnitPrice: 0,
          openingAmount: 0,
          closingStock: 0,
          closingUnitPrice: 0,
          closingAmount: 0
        });
        setIsOpeningDisabled(false);
        setIsClosingDisabled(false);
      }
      setIsBalanceEntry(true);
    } else {
      setIsSearchButtonVisible(true);
      setIsReportVisible(false);
      alert.error(response.message);
    }
  }

  async function GetProfitAndLossRTFDetails() {
    const year = parseInt(searchValues.applicableYear, 10);
    const month = parseInt(searchValues.applicableMonth, 10);
    const startDate = new Date(Date.UTC(year, month - 1, 1, 0, 0, 0, 0));     
    const endDate = new Date(Date.UTC(year, month, 0, 23, 59, 59, 999));
    
    let copDetailsModel = {
      groupID: parseInt(searchValues.groupID),
      factoryID: parseInt(searchValues.factoryID),
      startDate: startDate,
      endDate: endDate
    }
    const copResponse = await services.GetCopReportDetails(copDetailsModel);
    let totalFactoryOverhead = 0;
    let primaryCost = 0;
    let productionCost = 0;
    if (copResponse.statusCode == "Success" && copResponse.data != null) {
      copResponse.data.forEach(x => {
        if (x.categoryName === "Raw Materials" || x.categoryName === "Direct Labour") {
          primaryCost += x.amount
        }
        if (x.categoryName === "Factory Overheads") {
          totalFactoryOverhead += x.amount;
        }
      });
      productionCost = primaryCost + totalFactoryOverhead;
    }

    if (!IsOpeningDisabled || !IsClosingDisabled) {
      if (inventoryBalance.openingStock == 0 || inventoryBalance.openingUnitPrice == 0 || inventoryBalance.openingAmount == 0) {
        alert.error("Please Fill Opening Stock Details ")
        return;
      }
      else if (inventoryBalance.closingStock == 0 || inventoryBalance.closingUnitPrice == 0 || inventoryBalance.closingAmount == 0) {
        alert.error("Please Fill Closing Stock Details ")
        return;
      } else {
        await saveInventoryBalanceIfEmpty();
      }
    }

    let model = {
      groupID: parseInt(searchValues.groupID),
      factoryID: parseInt(searchValues.factoryID),
      applicableMonth: searchValues.applicableMonth,
      applicableYear: searchValues.applicableYear,
      openingBalance: parseFloat(openingAmountForReport),
      closingBalance: parseFloat(closingAmountForReport),
      productionCost: productionCost
    };
    const response = await services.getProfitAndLossRTFDetails(model);
    if (response !== null && response.statusCode === 'Success') {
      if (response.data.length == 0) {
        alert.error('No Records To Display');
        return;
      }
      addrofitAndLossRTFDetails(response.data);
      setIsReportVisible(true);
      setIsOpeningDisabled(true);
      setIsClosingDisabled(true); 
    } else {
      setIsReportVisible(false);
      alert.error(response.message);
    }
  }

  async function saveInventoryBalanceIfEmpty() {
    let addInventoryBalanceResponse;
    if (!IsOpeningDisabled && !IsClosingDisabled) {
      setIsOpeningDisabled(false);
      setIsClosingDisabled(false);
      let inventoryModel = {
        groupID: parseInt(searchValues.groupID),
        factoryID: parseInt(searchValues.factoryID),
        openingStock: parseFloat(inventoryBalance.openingStock),
        openingUnitPrice: parseFloat(inventoryBalance.openingUnitPrice),
        openingAmount: parseFloat(inventoryBalance.openingAmount),
        closingStock: parseFloat(inventoryBalance.closingStock),
        closingUnitPrice: parseFloat(inventoryBalance.closingUnitPrice),
        closingAmount: parseFloat(inventoryBalance.closingAmount),
        applicableMonth: searchValues.applicableMonth,
        applicableYear: searchValues.applicableYear,
        createdBy: parseInt(tokenDecoder.getUserIDFromToken()),
      }
      addInventoryBalanceResponse = await services.saveInventoryBalance(inventoryModel);
    } else if (!IsOpeningDisabled) {
      setIsOpeningDisabled(true);
      let inventoryModel = {
        groupID: parseInt(searchValues.groupID),
        factoryID: parseInt(searchValues.factoryID),
        openingStock: parseFloat(inventoryBalance.openingStock),
        openingUnitPrice: parseFloat(inventoryBalance.openingUnitPrice),
        openingAmount: parseFloat(inventoryBalance.openingAmount),
        closingStock: 0,
        closingUnitPrice: 0,
        closingAmount: 0,
        applicableMonth: searchValues.applicableMonth,
        applicableYear: searchValues.applicableYear,
        createdBy: parseInt(tokenDecoder.getUserIDFromToken()),
      }
      addInventoryBalanceResponse = await services.saveInventoryBalance(inventoryModel);
    } else if (!IsClosingDisabled) {
      setIsClosingDisabled(true);
      let inventoryModel = {
        groupID: parseInt(searchValues.groupID),
        factoryID: parseInt(searchValues.factoryID),
        openingStock: 0,
        openingUnitPrice: 0,
        openingAmount: 0,
        closingStock: parseFloat(inventoryBalance.closingStock),
        closingUnitPrice: parseFloat(inventoryBalance.closingUnitPrice),
        closingAmount: parseFloat(inventoryBalance.closingAmount),
        applicableMonth: searchValues.applicableMonth,
        applicableYear: searchValues.applicableYear,
        createdBy: parseInt(tokenDecoder.getUserIDFromToken()),
      }
      addInventoryBalanceResponse = await services.saveInventoryBalance(inventoryModel);
    }
    alert.success(addInventoryBalanceResponse.message);
  }

  function addrofitAndLossRTFDetails(data) {
    setStockValue({
      OpeningBalance: data.find(x => x.ledgerAccountCode === 'openingBalance')?.amount ?? 0,
      ProductionCost: data.find(x => x.ledgerAccountCode === 'productionCost')?.amount ?? 0,
      ClosingBalance: data.find(x => x.ledgerAccountCode === 'closingBalance')?.amount ?? 0,
    });
    setIncome({
      SalesProceedIncome: data.find(x => x.ledgerAccountCode === '4-02003002')?.amount ?? 0,
      RefuseTeaIncome: data.find(x => x.ledgerAccountCode === '4-02003003')?.amount ?? 0,
      LocalSales: data.find(x => x.ledgerAccountCode === '1-01006001')?.amount ?? 0,
      FertilizerSaleProfit: data.find(x => x.ledgerAccountCode === '4-02002001')?.amount ?? 0,
      InterestIncome: data.find(x => x.ledgerAccountCode === '4-02005001')?.amount ?? 0,
      GroceriesProfit: data.find(x => x.ledgerAccountCode === '4-02005002')?.amount ?? 0,
      TransportIncome: data.find(x => x.ledgerAccountCode === '4-02001001')?.amount ?? 0,
      VegetableSaleProfit: data.find(x => x.ledgerAccountCode === '4-02005003')?.amount ?? 0,
      ChemicalSaleProfit: data.find(x => x.ledgerAccountCode === '4-02005004')?.amount ?? 0,
      OtherIncome: data.find(x => x.ledgerAccountCode === '4-02004004')?.amount ?? 0
    });
    setAdministrationExpenses({
      Water: data.find(x => x.ledgerAccountCode === '5-02001032')?.amount ?? 0,
      TotalTelephoneChargersWithStarLink:  (data.find(x => x.ledgerAccountCode === '5-02001008')?.amount ?? 0) +  (data.find(x => x.ledgerAccountCode === '5-02001046')?.amount ?? 0),
      Bonus: data.find(x => x.ledgerAccountCode === '5-02001031')?.amount ?? 0,
      OfficeStaffSalary: data.find(x => x.ledgerAccountCode === '5-02001001')?.amount ?? 0,
      StaffEPF: data.find(x => x.ledgerAccountCode === '5-02001044')?.amount ?? 0,
      StaffETFWithEmployeeTrustFund: (data.find(x => x.ledgerAccountCode === '5-02001045')?.amount ?? 0) + (data.find(x => x.ledgerAccountCode === '2-02002016')?.amount ?? 0),
      MealsExpenses: data.find(x => x.ledgerAccountCode === '5-02003015')?.amount ?? 0,
      ElectricityCharges: data.find(x => x.ledgerAccountCode === '5-01002001')?.amount ?? 0,
      SundryExpenses: data.find(x => x.ledgerAccountCode === '5-02003009')?.amount ?? 0,
      PrintingAndStationary: data.find(x => x.ledgerAccountCode === '5-02001009')?.amount ?? 0,
      Postage: data.find(x => x.ledgerAccountCode === '5-02001012')?.amount ?? 0,
      SecurityOfficersSalary: data.find(x => x.ledgerAccountCode === '5-02001024')?.amount ?? 0,
      VehicleDepreciation: data.find(x => x.ledgerAccountCode === '5-02001038')?.amount ?? 0,
      FertilizerLoadingAndUnloading: data.find(x => x.ledgerAccountCode === '5-02004001')?.amount ?? 0,
      AnnualExpenses: data.find(x => x.ledgerAccountCode === '5-02003017')?.amount ?? 0,
    
    });
    setDistributionExpenses({
      MadeTeaTransport: data.find(x => x.ledgerAccountCode === '5-02002001')?.amount ?? 0,
      VehicleDepreciationColombo: data.find(x => x.ledgerAccountCode === '5-02002010')?.amount ?? 0,
      Brokerage: data.find(x => x.ledgerAccountCode === '5-02002002')?.amount ?? 0,
      SampleCost: data.find(x => x.ledgerAccountCode === '5-02002009')?.amount ?? 0,
      Fuel: data.find(x => x.ledgerAccountCode === '5-02001023')?.amount ?? 0,
      VehicleMaintenance: data.find(x => x.ledgerAccountCode === '5-01002008')?.amount ?? 0
    });
    setFinancialExpenses({
      LoanInterest: data.find(x => x.ledgerAccountCode === '5-02003010')?.amount ?? 0,
      ODInterest: data.find(x => x.ledgerAccountCode === '5-02003018')?.amount ?? 0,
      BankCharges: data.find(x => x.ledgerAccountCode === '5-02003013')?.amount ?? 0
    });
    setOtherExpenses({
      MedicalExpenses: data.find(x => x.ledgerAccountCode === '5-02001029')?.amount ?? 0,
      Donation: data.find(x => x.ledgerAccountCode === '5-02001022')?.amount ?? 0,
      Welfare: data.find(x => x.ledgerAccountCode === '5-02003008')?.amount ?? 0
    });
    setTotals({
      SalesTotal: data.find(x => x.ledgerAccountCode === 'salesTotal')?.amount ?? 0,
      StockValue: data.find(x => x.ledgerAccountCode === 'stockValue')?.amount ?? 0,
      GrossProfit: data.find(x => x.ledgerAccountCode === 'grossProfit')?.amount ?? 0,
      TotalOtherIncome: data.find(x => x.ledgerAccountCode === 'totalOtherIncome')?.amount ?? 0,
      TotalIncome: data.find(x => x.ledgerAccountCode === 'totalIncome')?.amount ?? 0,
      TotalAdministrationExpenses: data.find(x => x.ledgerAccountCode === 'totalAdminExpenses')?.amount ?? 0,
      TotalDistributionExpenses: data.find(x => x.ledgerAccountCode === 'totalDistributExpenses')?.amount ?? 0,
      TotalFinancialExpenses: data.find(x => x.ledgerAccountCode === 'totalFinancialExpenses')?.amount ?? 0,
      TotalOtherExpenses: data.find(x => x.ledgerAccountCode === 'totalOtherExpenses')?.amount ?? 0,
      TotalExpenses: data.find(x => x.ledgerAccountCode === 'totalExpenses')?.amount ?? 0,
      ProfitORLoss: data.find(x => x.ledgerAccountCode === 'ProfitOrLoss')?.amount ?? 0,
    })
  }
  function addSelectedSearchValues() {
    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    const monthIndex = (searchValues.applicableMonth === ''
      ? parseInt(moment(new Date()).format('MM'), 10)
      : parseInt(searchValues.applicableMonth, 10)
    ) - 1;
    setSelectedSearchValues({
      groupName: GroupList[searchValues.groupID],
      factoryName: FactoryList[searchValues.factoryID],
      applicableMonth: months[monthIndex],
      applicableYear: searchValues.applicableYear === "" ? moment(new Date()).format('YYYY') : searchValues.applicableYear,
    });
  }

  function handleInventoryBalanceChange(e) {
    setIsReportVisible(false);
    const target = e.target;
    const value = target.value;
    setInventoryBalance({
      ...inventoryBalance,
      [e.target.name]: value
    });
  }

  function handleChange(e) {
    setIsReportVisible(false);
    setIsBalanceEntry(false);
    setIsOpeningDisabled(false);
    setIsClosingDisabled(false); 
    setIsSearchButtonVisible(true);
    const target = e.target;
    const value = target.value;
    setSearchValues({
      ...searchValues,
      [e.target.name]: value
    });
  }

  function handleDateChange(date) {
    setIsReportVisible(false);
    setIsBalanceEntry(false);
    setIsOpeningDisabled(false);
    setIsClosingDisabled(false); 
    setIsSearchButtonVisible(true);
    let monthNames = ["JAN", "FEB", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUG", "SEPT", "OCT", "NOV", "DEC"];
    var month = date.getUTCMonth() + 1;
    var year = date.getUTCFullYear();
    let monthName = monthNames[month - 1];
    setSelectedSearchValues({
      ...selectedSearchValues,
      applicableMonth: month,
      applicableYear: year
    })
    setSearchValues({
      ...searchValues,
      applicableMonth: month.toString(),
      applicableYear: year.toString()
    });

    if (selectedDate != null) {

      var prevMonth = selectedDate.getUTCMonth() + 1
      var prevyear = selectedDate.getUTCFullYear();

      if ((prevyear == year && prevMonth != month) || (prevyear != year)) {
        setSelectedDate(date)
      }
    } else {
      setSelectedDate(date)
    }
  }


  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    );
  }

  async function createDataForExcelFromRows() {
    const aoa = [
      ['Group: ' + selectedSearchValues.groupName + ' Factoy: ' + selectedSearchValues.factoryName, '', '', ''],
      ['PROFIT AND LOSS STATEMENT FOR THE MONTH OF ' + selectedSearchValues.applicableMonth + ', ' + selectedSearchValues.applicableYear, '', '', ''],
      ['', '', '', ''],
      ['Description', '', '', ''],
      ['Sales', '', '', income.SalesProceedIncome],
      ['Cutter Tea', '', '', income.RefuseTeaIncome],
      ['Tea Sales Profit', '', '', income.LocalSales],
      ['', '', '', totals.SalesTotal],
      ['', '', '', ''],
      ['Cost of Sales', '', '', ''],
      ['Opening Finished Good', '', stockValue.OpeningBalance, ''],
      ['Manufacturing Cost', '', stockValue.ProductionCost, ''],
      ['', '', '', ''],
      ['Cutter Tea', '', '', ''],
      ['Locally Sold Stock', '', '', ''],
      ['', '', '', ''],
      ['Closing Finished Goods', '', stockValue.ClosingBalance, totals.StockValue],
      ['Gross Profit', '', '', totals.GrossProfit],
      ['', '', '', ''],
      ['Other Income', '', '', ''],
      ['Fertilizer Sale Profit', '', income.FertilizerSaleProfit, ''],
      ['Interest Income', '', income.InterestIncome, ''],
      ['Groceries Profit', '', income.GroceriesProfit, ''],
      ['Transport Income', '', income.TransportIncome, ''],
      ['Vegetable Sale Profit', '', income.VegetableSaleProfit, ''],
      ['Chemical Sale Profit', '', income.ChemicalSaleProfit, ''],
      ['Other Income', '', income.OtherIncome, totals.TotalOtherIncome],
      ['', '', '', totals.TotalIncome],
      ['', '', '', ''],
      ['Administration Expenses', '', '', ''],
      ['Water Bill', administrationExpenses.Water, '', ''],
      ['Telephone (SLT & Mobitel)', administrationExpenses.TotalTelephoneChargersWithStarLink, '', ''],
      ['New Year Bonus', administrationExpenses.Bonus, '', ''],
      ['Salary', administrationExpenses.OfficeStaffSalary, '', ''],
      ['EPF', administrationExpenses.StaffEPF, '', ''],
      ['ETF', administrationExpenses.StaffETFWithEmployeeTrustFund, '', ''],
      ['Meals Expenses', administrationExpenses.MealsExpenses, '', ''],
      ['Electricity', administrationExpenses.ElectricityCharges, '', ''],
      ['Sundry', administrationExpenses.SundryExpenses, '', ''],
      ['Printing & Stationery', administrationExpenses.PrintingAndStationary, '', ''],
      ['Postage', administrationExpenses.Postage, '', ''],
      ['Watchers', administrationExpenses.SecurityOfficersSalary, '', ''],
      ['Motor Vehicle Depreciation', administrationExpenses.VehicleDepreciation,'',''], 
      ['Fertilizer Loading and Unloading',administrationExpenses.FertilizerLoadingAndUnloading,'',''], 
      ['Annual Expenses',administrationExpenses.AnnualExpenses,totals.TotalAdministrationExpenses, ''],
      ['', '', '', ''],
      ['Distribution Expenses', '', '', ''],
      ['Colombo Tea Transport', distributionExpenses.MadeTeaTransport, '', ''],
      ['Motor Vehicle Depreciation (Colombo)', distributionExpenses.VehicleDepreciationColombo, '', ''],
      ['Marketing Cost', distributionExpenses.Brokerage, '', ''],
      ['Sample Cost', distributionExpenses.SampleCost, '', ''],
      ['Diesel Expenses', distributionExpenses.Fuel, '', ''],
      ['Vehicle Maintenance', '', totals.TotalDistributionExpenses, ''],
      ['', '', '', ''],
      ['Financial Expenses', '', '', ''],
      ['Loan Interest', financialExpenses.LoanInterest, '', ''],
      ['OD Interest', financialExpenses.ODInterest, '', ''],
      ['Bank Charges', financialExpenses.BankCharges, totals.TotalFinancialExpenses, ''],
      ['', '', '', ''],
      ['Other Expenses', '', '', ''],
      ['Medical', otherExpenses.MedicalExpenses, '', ''],
      ['Donation', otherExpenses.Donation, '', ''],
      ['Welfare', otherExpenses.Welfare, totals.TotalOtherExpenses, totals.TotalExpenses],
      ['Profit / (Loss)', '', '', totals.ProfitORLoss]
    ];

    return aoa;
  }

  async function exportSimpleExcel() {
    var aoa = await createDataForExcelFromRows();
    const worksheet = XLSX.utils.aoa_to_sheet(aoa);
    worksheet['!merges'] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: 3 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: 3 } },
    ];
    worksheet['!cols'] = [
      { wch: 25 },
      { wch: 12 },
      { wch: 12 },
      { wch: 12 }
    ];
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Profit & Loss Report - RTF');
    XLSX.writeFile(workbook, 'ProfitAndLossReportRTF - ' + selectedSearchValues.groupName + ' - ' + selectedSearchValues.factoryName
      + ' - ' + selectedSearchValues.applicableMonth + ', ' + selectedSearchValues.applicableYear + '.xlsx');
  }

  function handleInventoryBalanceChange(e, setFieldValue, values) {
    const { name, value } = e.target;
    setFieldValue(name, value);

    let updated = { ...inventoryBalance, [name]: value };

    let openingStock = name === "openingStock" ? parseFloat(value) : parseFloat(values.openingStock);
    let openingUnitPrice = name === "openingUnitPrice" ? parseFloat(value) : parseFloat(values.openingUnitPrice);

    if (!isNaN(openingStock) && !isNaN(openingUnitPrice)) {
      const openingAmount = (openingStock * openingUnitPrice).toFixed(2);
      updated.openingAmount = openingAmount;
      setFieldValue("openingAmount", openingAmount);
      setOpeningAmountForReport(openingAmount);
    } else {
      updated.openingAmount = 0;
      setFieldValue("openingAmount", 0);
    }

    let closingStock = name === "closingStock" ? parseFloat(value) : parseFloat(values.closingStock);
    let closingUnitPrice = name === "closingUnitPrice" ? parseFloat(value) : parseFloat(values.closingUnitPrice);

    if (!isNaN(closingStock) && !isNaN(closingUnitPrice)) {
      const closingAmount = (closingStock * closingUnitPrice).toFixed(2);
      updated.closingAmount = closingAmount;
      setFieldValue("closingAmount", closingAmount);
      setClosingAmountForReport(closingAmount);
    } else {
      updated.closingAmount = 0;
      setFieldValue("closingAmount", 0);
    }

    setInventoryBalance(updated);
  }

  const getPageMargins = () => {
    return `@media print {
        @page {
            background-color: white !important;
        }
   
        body {
            background-color: white !important;
        }
    }`;
  };

  const incomeLabels = ['Sales', 'Cutter Tea', 'Tea Sales Profit'];
  const incomeKeys = ['SalesProceedIncome', 'RefuseTeaIncome', 'LocalSales'];

  const stockLables = ['Opening Finished Goods', 'Manufacturing Cost'];
  const stockKeys = ['OpeningBalance', 'ProductionCost'];

  const otherIncomeLabels = ['Fertilizer Sale Profit', 'Interest Income', 'Groceries Profit', 'Transport Income', 'Vegetable Sale Profit', 'Chemical Sale Profit', 'Other Income'];
  const otherIncomeKeys = ['FertilizerSaleProfit', 'InterestIncome', 'GroceriesProfit', 'TransportIncome', 'VegetableSaleProfit', 'ChemicalSaleProfit', 'OtherIncome'];

  const administrationLabels = ['Water Bill', 'Telephone (SLT & Mobitel)', 'New Year Bonus', 'Salary', 'EPF', 'ETF', 'Meals Expenses', 'Electricity', 'Sundry', 'Printing & Stationery', 'Postage', 'Watchers', 'Motor Vehicle Depreciation','Fertilizer Loading and Unloading','Annual Expenses '];
  const administrationKeys = ['Water', 'TotalTelephoneChargersWithStarLink', 'Bonus', 'OfficeStaffSalary', 'StaffEPF', 'StaffETFWithEmployeeTrustFund', 'MealsExpenses', 'ElectricityCharges', 'SundryExpenses', 'PrintingAndStationary', 'Postage', 'SecurityOfficersSalary', 'VehicleDepreciation', 'FertilizerLoadingAndUnloading', 'AnnualExpenses'];

  const distributionExpensesLabels = ['Colombo Tea Transport', 'Motor Vehicle Depreciation (Colombo)', 'Marketing Cost', 'Sample Cost', 'Diesel Expenses', 'Vehicle Maintenance']
  const distributionExpensesKeys = ['MadeTeaTransport', 'VehicleDepreciationColombo', 'Brokerage', 'SampleCost', 'Fuel', 'VehicleMaintenance'];

  const financialExpensesLabels = ['Loan Interest', 'OD Interest', 'Bank Charges'];
  const financialExpensesKeys = ['LoanInterest', 'ODInterest', 'BankCharges'];

  const otherExpensesLabels = ['Medical', 'Donation', 'Welfare'];
  const otherExpensesKeys = ['MedicalExpenses', 'Donation', 'Welfare'];

  const cellCommonStyle = { border: '1px solid #e0e0e0', padding: '0.5rempx', paddingLeft: '1rempx', paddingRight: '1rempx', fontSize: '16px' };
  const cell40 = { ...cellCommonStyle, width: '40%' };
  const cell20 = { ...cellCommonStyle, width: '20%' };
  const cell100 = { ...cellCommonStyle, width: '100%' };
  const cell80 = { ...cellCommonStyle, width: '80%' };

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Card>
            <Formik
              initialValues={{
                groupID: searchValues.groupID,
                factoryID: searchValues.factoryID
              }}
              validationSchema={Yup.object().shape({
                groupID: Yup.number().required('Group is required').min(1, 'Group is required'),
                factoryID: Yup.number().required('Estate is required').min(1, 'Estate is required')
              })}
              onSubmit={() => trackPromise(GetOpeningClosingforPnLRTFDetails())}
              enableReinitialize
            >
              {({ errors, handleBlur, handleSubmit, touched }) => (
                <form onSubmit={handleSubmit}>
                  <Box mt={0}>
                    <Card>
                      <CardHeader title={cardTitle(title)} />
                      <PerfectScrollbar>
                        <CardContent>
                          <Grid container spacing={3}>
                            <Grid item md={4} xs={12}>
                              <InputLabel shrink id="groupID">
                                Group *
                              </InputLabel>
                              <TextField select
                                error={Boolean(touched.groupID && errors.groupID)}
                                fullWidth
                                helperText={touched.groupID && errors.groupID}
                                name="groupID"
                                onBlur={handleBlur}
                                onChange={(e) => handleChange(e)}
                                value={searchValues.groupID}
                                variant="outlined"
                                id="groupID"
                                size='small'
                                disabled={!permissionList.isGroupFilterEnabled}
                              >
                                <MenuItem value="0">--Select Group--</MenuItem>
                                {generateDropDownMenu(GroupList)}
                              </TextField>
                            </Grid>

                            <Grid item md={4} xs={12}>
                              <InputLabel shrink id="factoryID">
                                Estate *
                              </InputLabel>
                              <TextField
                                select
                                error={Boolean(touched.factoryID && errors.factoryID)}
                                fullWidth
                                helperText={touched.factoryID && errors.factoryID}
                                size="small"
                                name="factoryID"
                                onBlur={handleBlur}
                                onChange={e => {
                                  handleChange(e);
                                }}
                                value={searchValues.factoryID}
                                variant="outlined"
                                id="factoryID"
                              >
                                <MenuItem value="0">--Select Estate--</MenuItem>
                                {generateDropDownMenu(FactoryList)}
                              </TextField>
                            </Grid>

                            <Grid item md={4} xs={12}>
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <DatePicker
                                  autoOk
                                  variant="inline"
                                  openTo="month"
                                  views={["year", "month"]}
                                  label="Year and Month *"
                                  helperText="Select applicable month"
                                  value={selectedDate}
                                  onChange={(date) => handleDateChange(date)}
                                />
                              </MuiPickersUtilsProvider>
                            </Grid>
                          </Grid>

                          {IsSearchButtonVisible && <Box display="flex" flexDirection="row-reverse" p={2}>
                            <Button
                              color="primary"
                              type="submit"
                              variant="contained"
                              size="small"
                            >
                              Search
                            </Button>
                          </Box>}
                        </CardContent>
                      </PerfectScrollbar>
                    </Card>
                  </Box>
                </form>
              )}
            </Formik>

            {IsBalanceEntry && (
              <Formik
                initialValues={{
                  openingStock: inventoryBalance.openingStock,
                  openingUnitPrice: inventoryBalance.openingUnitPrice,
                  openingAmount: inventoryBalance.openingAmount,
                  closingStock: inventoryBalance.closingStock,
                  closingUnitPrice: inventoryBalance.closingUnitPrice,
                  closingAmount: inventoryBalance.closingAmount
                }}
                validationSchema={Yup.object().shape({
                  openingStock: Yup.number().required('Opening Stock is Required').min(0.01, 'Opening Stock is Required'),
                  openingUnitPrice: Yup.number().required('Opening Unit Price is Required').min(0.01, 'Opening Unit Price is Required'),
                  openingAmount: Yup.number().required('Opening Amount is Required').min(0.01, 'Opening Amount is Required'),
                  closingStock: Yup.number().required('Closing Stock is Required').min(0.01, 'Closing Stock is Required'),
                  closingUnitPrice: Yup.number().required('Closing Unit Price is Required').min(0.01, 'Closing Unit Price is Required'),
                  closingAmount: Yup.number().required('Closing Amount is Required').min(0.01, 'Closing Amount is Required'),
                })}
                enableReinitialize
                onSubmit={(values) => {
                  setInventoryBalance({
                    ...inventoryBalance,
                    openingStock: values.openingStock,
                    openingUnitPrice: values.openingUnitPrice,
                    openingAmount: values.openingAmount,
                    closingStock: values.closingStock,
                    closingUnitPrice: values.closingUnitPrice,
                    closingAmount: values.closingAmount
                  });
                  trackPromise(GetProfitAndLossRTFDetails());
                }}
              >
                {({ values, errors, handleBlur, handleSubmit, touched, handleChange, setFieldValue }) => (
                  <form onSubmit={handleSubmit}>
                    <Box mt={0}>
                      <Card>
                        <PerfectScrollbar>
                          <CardContent>
                            <Grid container spacing={3}>
                              <Grid item md={4} xs={12}>
                                <InputLabel shrink id="openingStock">
                                  Opening Stock (kg)
                                </InputLabel>
                                <TextField
                                  fullWidth
                                  name="openingStock"
                                  size="small"
                                  type="number"
                                  inputProps={{ step: "0.01" }}
                                  onChange={e => handleInventoryBalanceChange(e, setFieldValue, values)}
                                  onBlur={handleBlur}
                                  value={values.openingStock}
                                  variant="outlined"
                                  id="openingStock"
                                  disabled={IsOpeningDisabled}
                                  error={Boolean(touched.openingStock && errors.openingStock)}
                                  helperText={touched.openingStock && errors.openingStock}
                                />
                              </Grid>
                              <Grid item md={4} xs={12}>
                                <InputLabel shrink id="openingUnitPrice">
                                  Opening Stock Unit Price (Rs)
                                </InputLabel>
                                <TextField
                                  fullWidth
                                  name="openingUnitPrice"
                                  size="small"
                                  type="number"
                                  inputProps={{ step: "0.01" }}
                                  onChange={e => handleInventoryBalanceChange(e, setFieldValue, values)}
                                  onBlur={handleBlur}
                                  value={values.openingUnitPrice}
                                  variant="outlined"
                                  id="openingUnitPrice"
                                  disabled={IsOpeningDisabled}
                                  error={Boolean(touched.openingUnitPrice && errors.openingUnitPrice)}
                                  helperText={touched.openingUnitPrice && errors.openingUnitPrice}
                                />
                              </Grid>
                              <Grid item md={4} xs={12}>
                                <InputLabel shrink id="openingAmount">
                                  Opening Amount (Rs)
                                </InputLabel>
                                <TextField
                                  fullWidth
                                  name="openingAmount"
                                  size="small"
                                  type="number"
                                  inputProps={{ step: "0.01" }}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.openingAmount}
                                  variant="outlined"
                                  id="openingAmount"
                                  disabled={true}
                                />
                              </Grid>
                            </Grid>
                            <Grid container spacing={3}>
                              <Grid item md={4} xs={12}>
                                <InputLabel shrink id="closingStock">
                                  Closing Stock (kg)
                                </InputLabel>
                                <TextField
                                  fullWidth
                                  name="closingStock"
                                  size="small"
                                  type="number"
                                  inputProps={{ step: "0.01" }}
                                  onChange={e => handleInventoryBalanceChange(e, setFieldValue, values)}
                                  onBlur={handleBlur}
                                  value={values.closingStock}
                                  variant="outlined"
                                  id="closingStock"
                                  disabled={IsClosingDisabled}
                                  error={Boolean(touched.closingStock && errors.closingStock)}
                                  helperText={touched.closingStock && errors.closingStock}
                                />
                              </Grid>
                              <Grid item md={4} xs={12}>
                                <InputLabel shrink id="closingUnitPrice">
                                  Closing Stock Unit Price (Rs)
                                </InputLabel>
                                <TextField
                                  fullWidth
                                  name="closingUnitPrice"
                                  size="small"
                                  type="number"
                                  inputProps={{ step: "0.01" }}
                                  onChange={e => handleInventoryBalanceChange(e, setFieldValue, values)}
                                  onBlur={handleBlur}
                                  value={values.closingUnitPrice}
                                  variant="outlined"
                                  id="closingUnitPrice"
                                  disabled={IsClosingDisabled}
                                  error={Boolean(touched.closingUnitPrice && errors.closingUnitPrice)}
                                  helperText={touched.closingUnitPrice && errors.closingUnitPrice}
                                />
                              </Grid>
                              <Grid item md={4} xs={12}>
                                <InputLabel shrink id="closingAmount">
                                  Closing Amount (Rs)
                                </InputLabel>
                                <TextField
                                  fullWidth
                                  name="closingAmount"
                                  size="small"
                                  type="number"
                                  inputProps={{ step: "0.01" }}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.closingAmount}
                                  variant="outlined"
                                  id="closingAmount"
                                  disabled={true}
                                />
                              </Grid>
                            </Grid>
                            <Box display="flex" flexDirection="row-reverse" p={2}>
                              <Button
                                color="primary"
                                type="submit"
                                variant="contained"
                                size="small"
                              >
                                Generate
                              </Button>
                            </Box>
                          </CardContent>
                        </PerfectScrollbar>
                      </Card>
                    </Box>
                  </form>
                )}
              </Formik>
            )}

            <PerfectScrollbar>
              {IsReportVisible && (
                <Box minWidth={800}>
                  <Typography align='center' variant='h5' style={{paddingTop: '2rem'}}>PROFIT AND LOSS STATEMENT FOR THE MONTH OF {selectedSearchValues.applicableMonth}, {selectedSearchValues.applicableYear}</Typography>
                  <TableContainer style={{ width: '80%', margin: '2rem auto', border: '1px solid #e0e0e0', borderRadius: 4 }}>
                    <Table size="small" aria-label="simple table" style={{ borderCollapse: 'collapse', width: '100%' }}>
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan={4} align="left" style={cell100}>
                            <b>Description</b>
                          </TableCell>
                        </TableRow>

                        {incomeKeys.map((key, rowIndex) => (
                          <TableRow key={rowIndex}>
                            <TableCell align="left" style={cell40}>
                              {incomeLabels[rowIndex]}
                            </TableCell>
                            <TableCell align="right" style={cell20}></TableCell>
                            <TableCell align="right" style={cell20}></TableCell>
                            <TableCell align="right" style={cell20}>{income[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                          </TableRow>
                        ))}

                        <TableRow>
                          <TableCell colSpan={3} align="left" style={cell80}></TableCell>
                          <TableCell align="right" style={{ ...cell20, borderTop: '2px solid #000000' }}><b>{totals.SalesTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell colSpan={4} align="left" style={cell100}><u>Cost of Sales</u></TableCell>
                        </TableRow>

                        {stockKeys.map((key, rowIndex) => (
                          <TableRow key={rowIndex}>
                            <TableCell align="left" style={cell40}>
                              {stockLables[rowIndex]}
                            </TableCell>
                            <TableCell align="right" style={cell20}></TableCell>
                            <TableCell align="right" style={cell20}>{typeof stockValue[key] === 'number' ? stockValue[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : (stockValue[key] ?? '')}</TableCell>
                            <TableCell align="right" style={cell20}></TableCell>
                          </TableRow>
                        ))}
                        <TableRow>
                          <TableCell colSpan={4} align="left" style={{ ...cell100, height: '2rem' }}></TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell align="left" style={cell40}>Cutter tea</TableCell>
                          <TableCell align="right" style={cell20}></TableCell>
                          <TableCell align="right" style={cell20}></TableCell>
                          <TableCell align="right" style={cell20}></TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell align="left" style={cell40}>Locally sold stock</TableCell>
                          <TableCell align="right" style={cell20}></TableCell>
                          <TableCell align="right" style={cell20}></TableCell>
                          <TableCell align="right" style={cell20}></TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell colSpan={4} align="left" style={{ ...cell100, height: '2rem' }}></TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell align="left" style={cell40}>Closing Finished Goods</TableCell>
                          <TableCell align="right" style={cell20}></TableCell>
                          <TableCell align="right" style={{ ...cell20, borderBottom: '2px solid #000000' }}>{stockValue['ClosingBalance'].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                          <TableCell align="right" style={{ ...cell20, borderBottom: '2px solid #000000' }}><b>{totals.StockValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b> </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell align="left" style={cell40}>Gross Profit</TableCell>
                          <TableCell align="right" style={cell20}></TableCell>
                          <TableCell align="right" style={cell20}></TableCell>
                          <TableCell align="right" style={cell20}><b>{totals.GrossProfit.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell colSpan={4} align="left" style={{ ...cell100, height: '2rem' }}></TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell colSpan={4} align="left" style={cell100}><u>Other Income</u></TableCell>
                        </TableRow>

                        {otherIncomeKeys.map((key, rowIndex) => (
                          <TableRow key={rowIndex}>
                            <TableCell align="left" style={cell40}>
                              {otherIncomeLabels[rowIndex]}
                            </TableCell>
                            <TableCell align="right" style={cell20}></TableCell>
                            <TableCell align="right" style={rowIndex === otherIncomeKeys.length - 1 ? { ...cell20, borderBottom: '2px solid #000000' } : cell20}>{typeof income[key] === 'number' ? income[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : (income[key] ?? '')}</TableCell>
                            {rowIndex === otherIncomeKeys.length - 1 ? <TableCell align="right" style={{ ...cell20, borderBottom: '2px solid #000000' }}><b>{totals.TotalOtherIncome.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b> </TableCell> : <TableCell align="right" style={cell20}></TableCell>}
                          </TableRow>
                        ))}

                        <TableRow>
                          <TableCell colSpan={3} align="left" style={cell40}></TableCell>
                          <TableCell align="right" style={cell20}><b>{totals.TotalIncome.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell colSpan={4} align="left" style={{ ...cell100, height: '2rem' }}></TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell colSpan={4} align="left" style={cell100}><u>Administration Expenses</u></TableCell>
                        </TableRow>

                        {administrationKeys.map((key, rowIndex) => (
                          <TableRow key={rowIndex}>
                            <TableCell align="left" style={cell40}>
                              {administrationLabels[rowIndex]}
                            </TableCell>
                            <TableCell align="right" style={rowIndex === administrationKeys.length - 1 ? { ...cell20, borderBottom: '2px solid #000000' } : cell20}>
                              {typeof administrationExpenses[key] === 'number'
                                ? administrationExpenses[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                : (administrationExpenses[key] ?? '')}
                            </TableCell>
                            {rowIndex === administrationKeys.length - 1 ? <TableCell align="right" style={{ ...cell20, borderBottom: '2px solid #000000' }}><b>{totals.TotalAdministrationExpenses.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell> : <TableCell align="right" style={cell20}></TableCell>}
                            <TableCell align="right" style={cell20}></TableCell>
                          </TableRow>
                        ))}

                        <TableRow>
                          <TableCell colSpan={4} align="left" style={{ ...cell100, height: '2rem' }}></TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell colSpan={4} align="left" style={cell100}><u>Distribution Expenses</u></TableCell>
                        </TableRow>

                        {distributionExpensesKeys.map((key, rowIndex) => (
                          <TableRow key={rowIndex}>
                            <TableCell align="left" style={cell40}>
                              {distributionExpensesLabels[rowIndex]}
                            </TableCell>
                            <TableCell align="right" style={rowIndex === distributionExpensesKeys.length - 1 ? { ...cell20, borderBottom: '2px solid #000000' } : cell20}>
                              {typeof distributionExpenses[key] === 'number'
                                ? distributionExpenses[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                : (distributionExpenses[key] ?? '')}
                            </TableCell>
                            {rowIndex === distributionExpensesKeys.length - 1 ? <TableCell align="right" style={{ ...cell20, borderBottom: '2px solid #000000' }}><b>{totals.TotalDistributionExpenses.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell> : <TableCell align="right" style={cell20}></TableCell>}
                            <TableCell align="right" style={cell20}></TableCell>
                          </TableRow>
                        ))}

                        <TableRow>
                          <TableCell colSpan={4} align="left" style={{ ...cell100, height: '2rem' }}></TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell colSpan={4} align="left" style={cell100}><u>Financial Expenses</u></TableCell>
                        </TableRow>

                        {financialExpensesKeys.map((key, rowIndex) => (
                          <TableRow key={rowIndex}>
                            <TableCell align="left" style={cell40}>
                              {financialExpensesLabels[rowIndex]}
                            </TableCell>
                            <TableCell align="right" style={rowIndex === financialExpensesKeys.length - 1 ? { ...cell20, borderBottom: '2px solid #000000' } : cell20}>
                              {typeof financialExpenses[key] === 'number'
                                ? financialExpenses[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                : (financialExpenses[key] ?? '')}
                            </TableCell>
                            {rowIndex === financialExpensesKeys.length - 1 ? <TableCell align="right" style={{ ...cell20, borderBottom: '2px solid #000000' }}><b>{totals.TotalFinancialExpenses.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell> : <TableCell align="right" style={cell20}></TableCell>}
                            <TableCell align="right" style={cell20}></TableCell>
                          </TableRow>
                        ))}

                        <TableRow>
                          <TableCell colSpan={4} align="left" style={{ ...cell100, height: '2rem' }}></TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell colSpan={4} align="left" style={cell100}><u>Other Expenses</u></TableCell>
                        </TableRow>

                        {otherExpensesKeys.map((key, rowIndex) => (
                          <TableRow key={rowIndex}>
                            <TableCell align="left" style={cell40}>
                              {otherExpensesLabels[rowIndex]}
                            </TableCell>
                            <TableCell align="right" style={cell20}>
                              {typeof otherExpenses[key] === 'number'
                                ? otherExpenses[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                : (otherExpenses[key] ?? '')}
                            </TableCell>
                            {rowIndex === otherExpensesKeys.length - 1 ? <TableCell align="right" style={cell20}><b>{totals.TotalOtherExpenses.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b> </TableCell> : <TableCell align="right" style={cell20}></TableCell>}
                            {rowIndex === otherExpensesKeys.length - 1 ? <TableCell align="right" style={cell20}><b>{totals.TotalExpenses.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell> : <TableCell align="right" style={cell20}></TableCell>}
                          </TableRow>
                        ))}

                        <TableRow style={{ borderTop: '2px solid #000000' }}>
                          <TableCell colSpan={3} align="left" style={cell80}><b>Profit / (Loss)</b></TableCell>
                          <TableCell align="right" style={cell20}><b>{totals.ProfitORLoss.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell>
                        </TableRow>

                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Box display="flex" justifyContent="flex-end" p={2}>
                    <Button
                      color="primary"
                      id="btnRecord"
                      type="submit"
                      variant="contained"
                      style={{ marginRight: '1rem' }}
                      className={classes.colorRecord}
                      onClick={() =>
                        exportSimpleExcel()
                      }
                      size='small'
                    >
                      EXCEL
                    </Button>
                    <ReactToPrint
                      documentTitle={'ProfitAndLossReportRTF - ' + selectedSearchValues.groupName + ' - ' + selectedSearchValues.factoryName
                        + ' - ' + selectedSearchValues.applicableMonth + ', ' + selectedSearchValues.applicableYear}
                      trigger={() => (
                        <Button
                          color="primary"
                          id="btnRecord"
                          type="submit"
                          variant="contained"
                          style={{ marginRight: '1rem' }}
                          className={classes.colorCancel}
                          size='small'
                        >
                          PDF
                        </Button>
                      )}
                      pageStyle={getPageMargins()}
                      content={() => componentRef.current}
                    />

                    <div hidden={true}>
                      <CreatePDF
                        ref={componentRef}
                        stockValue={stockValue}
                        income={income}
                        administrationExpenses={administrationExpenses}
                        distributionExpenses={distributionExpenses}
                        financialExpenses={financialExpenses}
                        otherExpenses={otherExpenses}
                        totals={totals}
                        selectedSearchValues={selectedSearchValues}
                      />
                    </div>
                  </Box>
                </Box>
              )}
            </PerfectScrollbar>
          </Card>
        </Container>
      </Page>
    </Fragment>
  );
}